module.exports.Tabs = Tabs = {
  MEMBERS: 'members'
  MANAGED_MEMBERS: 'members/managed'
  BOARDGUESTS_MEMBERS: 'members/boardguests'
  DEACTIVATED_MEMBERS: 'members/deactivated'
  TEAMS: 'teams'
  PENDING_TEAMS: 'teams/pending'
  PUBLIC_BOARDS: 'boards/public'
  TEAM_SETTINGS: 'settings'
  SSO_SETTINGS: 'sso'
  POWER_UPS: 'power-ups'
  ALL_POWER_UPS: 'power-ups/all'
  IN_USE_POWER_UPS: 'power-ups/in-use'
  ALLOWED_POWER_UPS: 'power-ups/allowed'
  DISABLED_POWER_UPS: 'power-ups/disabled'
}

module.exports.Filters = Filters = {
  ACTIVITY: 'activity'
  ADMIN: 'admin-status'
  TEAMS: 'teams'
  TRANSFERRED: 'transferred'
}

module.exports.MembersSortItems = MembersSortItems = [
  { name: 'A-Z',  sortField: 'fullName', sortOrder: 'ascending' }
  { name: 'Z-A', sortField: 'fullName', sortOrder: 'descending' }
  { name: 'least-recently-active',  sortField: 'dateLastActive', sortOrder: 'ascending' }
  { name: 'most-recently-active', sortField: 'dateLastActive', sortOrder: 'descending' }
]

module.exports.PendingOrganizationsSortItems = PendingOrganizationsSortItems = [
  { name: 'A-Z', sortField: 'displayName', sortOrder: 'ascending' }
  { name: 'Z-A', sortField: 'displayName', sortOrder: 'descending' }
  { name: 'least-recently-created',  sortField: 'dateCreated', sortOrder: 'ascending' }
  { name: 'most-recently-created', sortField: 'dateCreated', sortOrder: 'descending' },
]

module.exports.PowerUpsSortItems = PowerUpsSortItems = [
  { name: 'most-used', sortField: 'boardsCount', sortOrder: 'descending' }
  { name: 'least-used',  sortField: 'boardsCount', sortOrder: 'ascending' }
  { name: 'A-Z',  sortField: 'name', sortOrder: 'ascending' }
  { name: 'Z-A', sortField: 'name', sortOrder: 'descending' }
]

module.exports.LDFlags = LDFlags = {
  SSO_SELF_SERVE: 'enterprise.sso_self_serve'
}

module.exports.PluginGroups = PluginGroups = {
  ALL: { name: 'all', tabs: [Tabs.ALL_POWER_UPS, Tabs.POWER_UPS] }
  IN_USE: { name: 'in-use', tabs: [Tabs.IN_USE_POWER_UPS] }
  NOT_IN_USE: { name: 'not-in-use', tabs: [] }
  ALLOWED: { name: 'allowed', tabs: [Tabs.ALLOWED_POWER_UPS] }
  DISABLED: { name: 'disabled', tabs: [Tabs.DISABLED_POWER_UPS] }
}



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/constants.coffee